module.exports = __webpack_public_path__ + "static/media/willemHoyngs.2795a80b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/willemHoyngs.jpg
// module id = 1598
// module chunks = 1